//cookie notifier hider
if (localStorage.getItem('cookiesgut') != 'true') {
    document.querySelector('.cookies-notifier').classList.add('visible');
}

document.querySelector('.cookies-notifier .button').addEventListener('click', event => {
    localStorage.setItem('cookiesgut', 'true');

    document.querySelector('.cookies-notifier').remove();
});